import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { OrderBar, OrdersReminder, Spinner} from 'components';
import { BASKET_CLEAR } from 'helpers/types';
import { ORDER_MEDICATION_SUCCESS } from 'helpers/monitoringEvents';
import checkImg from 'assets/check-circle-green.svg';
import styles from './styles.module.css';

import { useOrderHistory, useMonitoringEvents, useQuery, useOrders, useAnalytics } from 'hooks';

const Confirmation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [orderHistory, setOrderHistory] = useState([]);
  const [confirmedOrder, setConfirmedOrder] = useState({});
  const [getOrderHistory] = useOrderHistory();
  const [postLog] = useMonitoringEvents();
  const [, postConfirmation] = useOrders();
  const query = useQuery();
  const [postFloodlight] = useAnalytics();
  postFloodlight({ code: 'heyph002' });

  const manualOrderTypes = ['pharmacyUi', 'titan'];

  useEffect(() => {
    const ckoSessionId = query.get('cko-session-id');
    async function confirmCKO() {
      if (ckoSessionId) {
        const returnedOrder = await postConfirmation(ckoSessionId);
        setConfirmedOrder(returnedOrder);
        if (!manualOrderTypes.includes(returnedOrder.created_from)) {
          setOrderHistory(await getOrderHistory());
        }
      } else {
        setOrderHistory(await getOrderHistory());
      }
    }
    confirmCKO();

    postLog(ORDER_MEDICATION_SUCCESS);
    dispatch({ type: BASKET_CLEAR });
  }, []);

  useEffect(() => {
    if (orderHistory[0] || manualOrderTypes.includes(confirmedOrder.created_from)) {
      setIsLoading(false);
    }
  }, [orderHistory, confirmedOrder]);

  if (isLoading) {
    return (
      <>
        {<OrderBar currentProgress={2} />}
        <div className="coop-l-container">
          <div className={styles.spinnerPadding}>
            <Spinner />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {<OrderBar currentProgress={3} />}
      <div className="coop-l-container">
        <div className={`coop-l-large-6 ${styles.container}`}>
          <img src={checkImg} className={styles.icon} alt="Green tick" />
          {manualOrderTypes.includes(confirmedOrder.created_from) ? (
            <>
              <h1 className={styles.header}>Payment received</h1>
              <p>
                Thank you, your order has been placed and we will start working on it. We will notify you when your
                order has been dispensed.
              </p>
              <button
                className={`coop-btn coop-btn--primary ${styles.button}`}
                onClick={() => history.push('/pharmacy/dashboard?view=order')}>
                Continue
              </button>
            </>
          ) : (
            <>
              <h1 className={styles.header}>Your request has been sent</h1>
              <p>
                Your request for medication has been securely sent to your GP surgery to check - we’ll let you know when
                they’ve done this.
              </p>
              {orderHistory && orderHistory[0]?.fulfillment.delivery_type === 'collectFromPharmacy' && (
                <p>
                  Your order will be sent to{' '}
                  <span className={styles.confirmationPharmacyName}>{orderHistory[0]?.fulfillment.pharmacy_name}</span>
                </p>
              )}
              <h3 className={styles.header}>Medication requested</h3>
              {orderHistory[0]?.order_items.map((item) => {
                return (
                  <div className={styles.reminder}>
                    <h2 className={styles.header}>{item.name}</h2>
                    <p>{item.instructions.slice(0, item.instructions.search(/(\r\n|\r|\n)/g))}</p>
                  </div>
                );
              })}
              <OrdersReminder
                orderId={orderHistory[0]?.order_id}
                redirectFn={() => history.push(`/pharmacy/dashboard?view=order`)}
                submitText={'Continue'}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Confirmation;
